import React from 'react'
import * as Sentry from '@sentry/react'
import { APP_VERSION } from 'version'

import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    dsn: 'https://bdb286552bd38381f647c5dc31f4fa98@o4505942099230720.ingest.sentry.io/4505942563553280',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.extraErrorDataIntegration(),
      Sentry.httpClientIntegration(),
    ],
    tracesSampleRate: 1,
    environment: import.meta.env.MODE,
    release: APP_VERSION,
  })
}

export const sentryCreateBrowserRouter =
  import.meta.env.MODE === 'development'
    ? createBrowserRouter
    : Sentry.wrapCreateBrowserRouter(createBrowserRouter)
